$(document).ready(function() {
/*    $('.masonry-grid').masonry({
        itemSelector: '.masonry-item',
        columnWidth: 200
    });*/
});